/* unplugin-vue-components disabled */import script from "./FilterSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSelector.vue?vue&type=script&setup=true&lang=js"

import "./FilterSelector.vue?vue&type=style&index=0&id=2d8b9a33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8b9a33"]])

export default __exports__